import React, { useState,useEffect } from 'react';
import { useNavigate,useParams,useLocation} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './nicepage.css';
import './Dashboard.css';
import axios from 'axios';
import Header from './Header';
import SearchBar from './SearchBar';
import Swal from 'sweetalert2';
import DataTableComponent from './DataTableComponent';
import RemarkModal from './RemarkModal';
import { Button } from 'react-bootstrap';
import eventBg from '../images/eventbg.jpg'

const ShowPmEstimateEvent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [refreshData,setRefreshData] = useState(0);
    const [estimateData,setEstimateData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5);
    const { eventId } = useParams();
    const [searchTerm, setSearchTerm] = useState('');
    const [loading,setLoading] = useState("");
    const [showRemarkModal,setShowRemarkModal] = useState(false);
    const [estimateType,setEstimateType] = useState("");
    const [typeofEstimate,setTypeofEstimate] = useState("");
    const [remarksData,setRemarksData] = useState("EXHIBITION");
    const pmName = location.state?.pmName || 'Unknown PM';
    const companyName = location.state?.companyName || 'Unknown Company';
    const pmId = location.state?.pmId || sessionStorage.getItem('pmId') || '';
    const clientId = location.state?.clientId ||sessionStorage.getItem('clientId') || '';
    console.log("estimatedashboard1 = ",clientId);
    const compId = location.state?.compId || '';
    const role = location.state?.role || sessionStorage.getItem('role') || '';
    useEffect(() => {
        const fetchData = async () => {
           setLoading(true);
            try {
                let response = "";
                if(role == 1){
                    response = await axios.post(`${process.env.REACT_APP_API_URL}/client_estimate`, { eventid: eventId});
                }
                else{
                    response = await axios.post(`${process.env.REACT_APP_API_URL}/pm_estimate`, { pmid: pmId, eventid:eventId});
                }
                
                if(response.status == 200){
                    // setRefreshData(0);
                    const estimates = response.data.data;
                    console.log("estimates = ",estimates);
                    setTypeofEstimate(estimates.estimate_type)
                    setEstimateData(estimates || []);
                }
            } catch (err) {
                setFilteredData([])
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [refreshData, navigate]);
    useEffect(() => {
        const filtered = estimateData.filter(item =>
            (item.id?.toString().toLowerCase().includes(searchTerm.toLowerCase()) || '') ||
            (item.date?.toString().toLowerCase().includes(searchTerm.toLowerCase()) || '')
        );
        setFilteredData(filtered);
        setCurrentPage(1);
    }, [searchTerm, estimateData]);
    const handleEditEstimate = (e,estimateId) =>{
        const index = estimateData.findIndex(item => item.id === estimateId);
        e.preventDefault();
        navigate(`/dashboard/editestimatesevent/${eventId}`,
        {state:
            {   
                role : role,
                pmId : pmId,
                estimateType : estimateData[index].estimate_type,
                estimateNo : estimateId,
                estimate_data_selected : estimateData[index].estimate_data_selected
            }
        });
    }
    const handleMore = (e,estimateId) => {
        e.preventDefault();
        navigate(`/dashboard/showestimates/${eventId}/moreestimates/${estimateId}`,{
            state:{
                pmId : pmId,
                eventId:eventId,
                estimateId:estimateId,
                role:role,
                pmName:pmName,
                companyName:companyName
            }
        })
    }
    const handleRequest = async(e,estimateId) => {
        e.preventDefault();
        try{
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/updateStatus`,
            {
                estimate_id: estimateId,
                status:"Request For Change"
            });
            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Request By Client',
                    text: response.data.message || 'Request was successful.',
                    confirmButtonText: 'OK',
                    preConfirm: () => {
                        setRefreshData(refreshData + 1);
                    }
                });

            } else {
                Swal.fire({
                    icon: 'warning',
                    title: 'Unexpected Response',
                    text: `Received unexpected status code: ${response.status}`,
                });
            }
        }
        catch(e){
            console.log(e.message);
        }
    }
    const handleView = (e,role,estimateId) => {
        e.preventDefault();
        const index = estimateData.findIndex(item => item.id === estimateId);
        console.log("index = ",index);
        navigate(`viewestimates/${estimateId}`,
        {state:
            {
                role:role,
                eventId : eventId,
                pmId : pmId,
                pmName : pmName,
                companyName : companyName,
                estimateType : estimateData[index].estimate_type,
                totalCost : estimateData[index].client_total,
                estimate_data_selected : estimateData[index].estimate_data_selected,
            }
        }
        );
    }
    const handleRemarks = (e,remarks,estimateType) => {
        e.preventDefault();
        setEstimateType(estimateType);
        setRemarksData(remarks);
        setShowRemarkModal(true);
    }
    const handleCloseRemarks = () => {
        setShowRemarkModal(false);
    }
    const handlePageChange = page => {
        setCurrentPage(page);
    };
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };
    const handleShowEstimate = () => {
        sessionStorage.setItem('clientId', clientId);
        sessionStorage.setItem('eventid', eventId);
        navigate(`/dashboard/showestimateseevent/${eventId}`,
            {state:
                {
                    eventId,eventId,
                    role:role,
                    pmId : pmId,
                    compId : compId,
                    pmName : pmName,
                    companyName : companyName,
                    clientId : clientId
                }
            });
    }
    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#38077B',
                color: '#fff',
                fontSize: '16px',
                whiteSpace: 'normal', // Allows text to wrap in header cells
                overflow: 'visible',  // Ensures text is not clipped
                wordBreak: 'break-word', // Breaks long words
            },
        },
        cells: {
            style: {
                color: 'black',
                backgroundColor: 'white',
                fontSize: '16px',
                whiteSpace: 'normal', // Allows text to wrap in cells
                overflow: 'visible',  // Ensures text is not clipped
                wordBreak: 'break-word', // Breaks long words
            },
            highlightOnHoverStyle: {
                color: 'white',
                backgroundColor: '#478AC9',
            },
        },
    };

    // Function to get column widths based on role
    const getColumnWidths = () => {
        return {
            estimateNumber: "180px",
            date: "180px",
            clientApproval: "180px",
            purchaseApproval: "190px",
            Remarks : "120px",
            actions: "450px",
        };
    };

    // Get column widths based on the current role
    const columnWidths = getColumnWidths();

    // Define the columns based on the role
    const columns = [
        {
            name: 'Estimate Number',
            selector: row => row.id,
            width: columnWidths.estimateNumber,
            sortable: true,
            wrap: true
        },
        {
            name: 'Date of Creation',
            selector: row => row.date,
            width: columnWidths.date,
            sortable: true,
            wrap: true
        },
        {
            name: role == 1 ? 'status' : 'Client Approval',
            selector: row => row.status,
            width: columnWidths.clientApproval,
            sortable: true,
            wrap: true,
            cell: row => {
                let statusText = row.status;
                let buttonStyle = "";
                if (statusText === 'pending') {
                    buttonStyle = "btn btn-danger";
                } else if (statusText === 'Approved By Client') {
                    buttonStyle = "btn btn-success";
                }
                else if (statusText == 'change_by_pm'){
                    buttonStyle = "btn btn-warning text-white";
                }
                else{
                    statusText = 'R & C'
                    buttonStyle = "btn btn-info text-white";
                }
                return (
                        <button className = {buttonStyle}>
                            {statusText}
                        </button>   
                );
            }   
        },
        {
            name: 'Purchase Approval',
            selector: row => {
                let statusText = row.approvals;
                let buttonStyle = "";
                let fontSize  = "";
                if (statusText === 'Approved By Purchase') {
                    buttonStyle = "btn btn-success";
                    fontSize = "13px";
                } 
                else{
                    statusText = 'Pending'
                    buttonStyle = "btn btn-danger";
                    fontSize = "16.5px";
                    
                }
                return (
                        <button className = {buttonStyle} style = {{fontSize:fontSize}}>
                            {statusText}
                        </button>   
                );
            },
            width: columnWidths.purchaseApproval,
            sortable: true,
            wrap: true
        },
        {
            name: 'Remarks',
            width: columnWidths.Remarks,
            selector: row  => {
                if(row.remarks){
                    return (
                        <a
                        href=""
                        className='tableAction1Blue' style = {{width:'84px'}}
                        title="View"
                        onClick={(e) => handleRemarks(e,row.remarks,row.estimate_type)}
                        >
                        Remarks
                        </a>
                    )
                } else return ('NA')
            },
            sortable: true,
            wrap: true
        },
        {
            name: 'Actions',
            width: columnWidths.actions,
            cell: row => (
                <div className="d-flex justify-content-space">
                    <a
                        href=""
                        className='tableAction'                        title="View"
                        onClick={(e) => { (handleView(e,role,row.id)) }}
                    >
                        VIEW
                    </a>
                    {role == 1 ?  
                    <a
                        href=""
                        className='tableAction'                        title="View"
                        onClick={(e) => { handleRequest(e,row.id) }}
                    >
                        R&C
                    </a> : 
                    <a
                        href=""
                        className='tableAction'                        title="View"
                        onClick={(e) => { handleEditEstimate(e,row.id) }}
                    >
                        EDIT
                    </a>
                    }
                  
                    <a
                        href=""
                        className='tableAction'
                        title="View"
                        onClick={(e) => {handleMore(e,row.id)}}
                    >
                        MORE
                    </a>
                </div>
            ),
        }
    ];

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    return (
        <>
            <div className="u-body u-xl-mode" data-lang="en">
                <Header imagTag = '../../' role = {role} active = {{estimates:1}}/>
                <div className="bg-image-container">
              <img src={eventBg} alt="event background" className="img-fluid" />
              <div className="title_name">
                <p style={{ fontSize: "5rem" }}>ESTIMATES</p>
                     <div className="container mt-2 mb-2 d-flex align-items-center justify-content-center">
                            <SearchBar searchTerm={searchTerm} onSearchChange={handleSearchChange}/>
                        </div>
                <div
                  className="d-flex align-items-center justify-content-between w-50"
                  style={{ gap: "25px" }}
                >
                    {
                        role == 1 && (
                        <Button
                            className={
                            window.location.pathname == "/dashboard"
                                ? "active_btn"
                                : "addNewBtn"
                            }
                            size="lg"
                            onClick={handleShowEstimate}
                        >
                            Create Estimate
                        </Button>
                        )
                    }
                  
                </div>
                {/* <p className='company_name'><span>{companyName}</span></p> */}
                {/* <div className="container mt-2 mb-2 d-flex align-items-center justify-content-center">
                            <SearchBar searchTerm={searchTerm} onSearchChange={handleSearchChange}/>
                        </div>
                        <div className='d-flex align-items-center'>
                            {role == 1 && <div className = 'col-12 col-lg-2 col-md-2 mt-2 mb-2'><Button className="addNewBtn" size="lg" onClick={handleShowEventModal}>
                                Add New Event
                            </Button></div> }
                        </div> */}
              </div>
            </div>
                <section className="u-align-center u-clearfix u-section-1" id="sec-0e20">
                    <div className="u-clearfix u-sheet u-sheet-1">
                        {/* <div className="data-layout-selected u-clearfix u-expanded-width u-layout-wrap u-palette-5-light-3 u-layout-wrap-1">
                            <div className="u-gutter-0 u-layout">
                                <div className="u-layout-row">
                                {role == 1 ? 
                                <>
                                <div className="u-align-center u-container-style u-layout-cell u-size-30 u-layout-cell-1">
                                        <div className="u-container-layout u-container-layout-1">
                                            <h4 className="u-align-center u-text u-text-1">Company Name : {companyName}</h4>
                                        </div>
                                    </div> 
                                    <div className="u-align-center u-container-style u-layout-cell u-size-30 u-layout-cell-1">
                                        <div className="u-container-layout u-container-layout-1">
                                            <h4 className="u-align-center u-text u-text-1">PM : {pmName}</h4>
                                        </div>
                                    </div>
                                </>
                                :
                                <div className="u-align-center u-container-style u-layout-cell u-size-60 u-layout-cell-1">
                                        <div className="u-container-layout u-container-layout-1">
                                            <h4 className="u-align-center u-text u-text-1">PM : {pmName}</h4>
                                        </div>
                                    </div>
                                    
                                }
                                </div>
                            </div>
                        </div> */}
                        {/* <div className="container">
                            <div className="row align-items-center mt-5 mb-5">
                                <SearchBar searchTerm={searchTerm} onSearchChange={handleSearchChange} />
                                {role == 1 ? <div className = 'col-12 col-lg-2 col-md-2 mt-2 mb-2'><Button variant="outline-danger" size="lg" onClick={handleShowEstimate}>
                                Create Estimate
                            </Button></div> : ''}
                            </div>
                        </div> */}
                        <DataTableComponent
                            data={currentItems}
                            columns={columns}
                            loading={loading}
                            pagination={{ customStyles }}
                           
                            paginationServer
                            paginationTotalRows={filteredData.length}
                            handlePageChange={handlePageChange}
                            itemsPerPage={itemsPerPage}
                            
                        />
                        <RemarkModal 
                            remarksData={remarksData}
                            estimateType={estimateType}
                            show={showRemarkModal}
                            handleClose={handleCloseRemarks}
                        />
                    </div>

                </section>
            </div>
        </>
    );
}
export default ShowPmEstimateEvent;